import { AuthFacade } from '../../auth/state/auth.facade';
import { HttpRequest, HttpHandler, HttpInterceptor, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Observable } from 'rxjs';
import { take, switchMap, defaultIfEmpty } from 'rxjs/operators';

@Injectable()
export class LocationInterceptor implements HttpInterceptor {

	constructor(private authFacade: AuthFacade, private zone: NgZone) {

	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return this.authFacade.location$.pipe(take(1), defaultIfEmpty(null), switchMap(location => {
			// location$ is fed by geolocation state that has, in the past, been updated from outside
			// Angular's zone (see auth.effects.ts's updateCoordinates$) - since every HTTP request in
			// the app passes through here, re-entering the zone before opening the request is cheap
			// insurance against that class of bug reintroducing itself app-wide.
			return this.zone.run(() => {
				if (location?.latitude && location?.longitude) {
					const newRequest = req.clone({
						headers: req.headers
							.set('Latitude', location.latitude.toString())
							.set('Longitude', location.longitude.toString())
					});
					return next.handle(newRequest);
				} else {
					return next.handle(req);
				}
			});
		}));
	}
}
